import { Entry } from '../Entry'

export function Entry20220414() {
  return (
    <Entry title="14/04/2022 - v3.0.0-RC1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12455/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
